import React from 'react';

import 'css/components/www/_Quotes.scss';

import LazyLoadedImage from 'common/LazyLoadedImage';
import { P } from 'common/ui/Text';

type Props = {
  name: string;
  image: string;
  title: React.ReactNode | string;
};
const QuotePerson = ({ name, image, title }: Props) => {
  return (
    <div className="person">
      <div className="personImageWrapper">
        <LazyLoadedImage className="personImage" alt={name} src={image} />
      </div>
      <div>
        <P className="personName" variant="bodyMd" fontWeight="bold">
          {name}
        </P>
        <P className="personTitle" variant="bodySm">
          {title}
        </P>
      </div>
    </div>
  );
};

export default QuotePerson;
